import { FC } from 'react';
import { StyledBackground } from './Background.styled';
import { StyledBackgroundProps } from './Background.type';

export const Background: FC<StyledBackgroundProps> = ({
  children,
  ...rest
}) => <StyledBackground {...rest}>{children}</StyledBackground>;
